import React from 'react';
import styled from 'styled-components';

type ButtonVariant = 'default' | 'primary';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  icon?: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'default',
  icon,
  children,
  ...rest
}) => {
  return (
    <Btn $variant={variant} {...rest}>
      {icon}
      {children}
    </Btn>
  );
};

const Btn = styled.button<{ $variant: ButtonVariant }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 13px;
  border-radius: 7px;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid
    ${({ $variant }) => ($variant === 'primary' ? 'var(--ink)' : 'var(--line)')};
  background: ${({ $variant }) =>
    $variant === 'primary' ? 'var(--ink)' : 'var(--white)'};
  color: ${({ $variant }) =>
    $variant === 'primary' ? 'var(--white)' : 'var(--ink)'};
  transition: all 0.15s;
  white-space: nowrap;

  &:hover {
    background: ${({ $variant }) =>
      $variant === 'primary' ? 'var(--terracotta)' : 'var(--white)'};
    border-color: ${({ $variant }) =>
      $variant === 'primary' ? 'var(--terracotta)' : 'var(--ink)'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;
